import { put, takeLatest } from 'redux-saga/effects';

function* rerender(action) {
  yield put({ type: 'AUTH/GET_CURRENT_USER_REQUEST' });
  yield put({ type: 'persist/REHYDRATE_SUCCESS' });
}

export const persistSagas = [takeLatest('persist/REHYDRATE', rerender)];
